export const ICON = {
  UP: "ChevronUp",
  DOWN: "ChevronDown",
  LEFT: "ChevronLeft",
  RIGHT: "ChevronRight",
  ATTACH: "Attach",
  DOCX: "WordDocument",
  PDF: "PDF",
  EXCEL: "ExcelDocument",
  PIC: "PhotoCollection",
  PPT: "PowerPointDocument",
  CANCEL: "Cancel",
  SEARCH: "Search",
  ICON: "icon",
  ICON_DISABLED: "icon-disabled",
  TEXT_DOCUMENT: "TextDocument",
  SETTINGS: "Settings",
  ADVANCE_PAGE: "BulkUpload",
};
